let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("brMdv")).then(() => parcelRequire('4XTq5'));